import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation, PapiUser } from '@wix/da-types-papi';
import { MeasuredCookieType } from '@wix/da-shared-react/pkg/Measured';
import DeviationTorpedo from '@wix/da-shared-react/pkg/Torpedo/DeviationTorpedo';
import DuperbrowseContext from '../../../contexts/DuperbrowseContext';
import OverlayContext from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import { hashNumbers } from '../../../utils/hash';
import {
  ExhibitionistViewMode,
  ExhibitionistSlideFitMode,
} from '../../../../types/modules';
import DeviationSlideshow from './DeviationSlideshow';

import s from './TallExhibitionist.scss';

export interface Props {
  viewMode: ExhibitionistViewMode;
  slideImageFit: ExhibitionistSlideFitMode;
  streamId: string;
  deviations: PapiDeviation[];
  seeAllUrl: string;
  profileOwnerUser: PapiUser;
  sourceType?: string;
  isCurrentUserProfileOwner: boolean;
}

// DeviationTorpedo configuration params
const container = { width: 450, maxRows: 3 };
const defaultSize = {
  desktop: { width: 450, height: 0 },
  mobile: { width: 375, height: 0 },
};

export class TallExhibitionist extends React.Component<
  Props & WithTranslation
> {
  render() {
    const {
      deviations,
      profileOwnerUser,
      t,
      streamId,
      viewMode,
      sourceType,
      isCurrentUserProfileOwner,
    } = this.props;
    const isCollection = sourceType && sourceType === 'collection';

    const num = hashNumbers(
      ...deviations.map(deviation => deviation.deviationId)
    );
    return (
      <div className={s['root']} key={num.toString()}>
        <DuperbrowseContext
          streamId={streamId}
          deviations={deviations}
          parent={{
            title: t('common.someonesProfile', profileOwnerUser),
          }}
        >
          <OverlayContext.Provider
            value={{
              showPermanentIconWhenFaved: !(
                isCollection && isCurrentUserProfileOwner
              ),
            }}
          >
            {viewMode === ExhibitionistViewMode.SLIDESHOW
              ? this.renderSlideshow()
              : this.renderTorpedo()}
          </OverlayContext.Provider>
        </DuperbrowseContext>
      </div>
    );
  }

  renderTorpedo = () => (
    <DeviationTorpedo
      items={this.props.deviations}
      container={container}
      cookieType={MeasuredCookieType.USER_PROFILE_FEATURED}
      cookieDim={'width'}
      defaultSize={defaultSize}
      hideIncompleteRows
    />
  );

  renderSlideshow = () => (
    <DeviationSlideshow
      items={this.props.deviations}
      useCoverMode={
        this.props.slideImageFit === ExhibitionistSlideFitMode.COVER
      }
    />
  );
}

export default withTranslation()(TallExhibitionist);
